/** @description Вычисляет порядковый номер нового слайда на который произошел сдвиг
 * @param {number} props.currentSlide порядковый номер текущего слайда
 * @param {number} props.totalSlides общее количество слайдов
 * @param {number} props.direction направление сдвига
 * @param {number} props.slidesToScroll количество слайдов на которое произошел сдвиг
 * @param {number} props.slidesToShow число одновременно отображаемых слайдов на экране
 * @return {number}
 */
export function calculateNextSlide(props) {
  var currentSlide = props.currentSlide,
    totalSlides = props.totalSlides,
    direction = props.direction,
    slidesToScroll = props.slidesToScroll,
    slidesToShow = props.slidesToShow;
  return checkBoundaryValues(currentSlide + direction * slidesToScroll, slidesToShow, totalSlides);
}

/** @description Возвращает проверяемое значение если оно в диапазоне [min,max] или ближайшую к нему границу иначе.
 * @param {number} value проверяемое значение
 * @param {number} min нижняя граница диапазона
 * @param {number} max верхняя граница диапазона
 * @return {number}
 */
export function checkBoundaryValues(value, min, max) {
  if (value <= min) {
    return min;
  } else if (value >= max) {
    return max;
  }
  return value;
}